/*
   A uniform way to report response errors.
*/
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResponseError = (function (_Error) {
  _inherits(ResponseError, _Error);

  function ResponseError(message, response, endpoint) {
    _classCallCheck(this, ResponseError);

    _get(Object.getPrototypeOf(ResponseError.prototype), 'constructor', this).call(this);

    this.message = [message, '>>> Response Status: ' + response._status, '>>> Endpoint URL: ' + endpoint.url, '>>> Arguments: ' + JSON.stringify(endpoint.args, null, 2), '>>> Response Body:', response._body].join('\n\n');

    this.url = endpoint.url;
    this.args = endpoint.args;
    this.status = response._status;
    this.body = response._body;
    this.retryAttemptsLeft = endpoint.contextOptions.retryAttemptsLeft;
    this.endpoint = endpoint;
  }

  return ResponseError;
})(Error);

exports['default'] = ResponseError;
module.exports = exports['default'];
//# sourceMappingURL=ResponseError.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/snoocore/build/src/ResponseError.js
// module id = 129
// module chunks = 0